import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { toast } from "sonner";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Error toast with an Arabic "Retry" action. Pass a retry callback for
 * network / transient failures; omit it for permanent errors.
 */
export function errorToast(message: string, retry?: () => void | Promise<void>) {
  if (retry) {
    toast.error(message, {
      action: {
        label: "إعادة المحاولة",
        onClick: () => {
          void retry();
        },
      },
    });
  } else {
    toast.error(message);
  }
}
